<!--赖传峰-->
<!--2023/5/6-->
<script lang="ts" setup>
import { computed, ref } from '#imports'
import DownIcon from '@/components/icons/ArrowDownIcon.vue'
import BaseSorterShim from '@/components/share/BaseSorterShim.vue'
import type { OrderType } from '@/store/share.script'
import { FileOrder } from '@/types/enum'
import useDisplayMode from '~/composables/useDisplayMode'

const emits = defineEmits<{ afterSort: [] }>()
const { size, defaultOrderType, useDefaultOrderType } = defineProps<{
  size?: 'small'
  defaultOrderType?: OrderType
  useDefaultOrderType?: boolean
  showShim?: boolean
}>()

const popoverRef = ref()
const { orderType } = useDisplayMode()

const orderTypeValue = computed(() => {
  if (defaultOrderType && useDefaultOrderType) return defaultOrderType
  return orderType.value
})

const orderOptions: {
  type: OrderType
  title: string
}[] = [
  {
    type: FileOrder.NAME_ASC,
    title: 'sorter-name-ascend',
  },
  {
    type: FileOrder.NAME_DESC,
    title: 'sorter-name-descend',
  },
  {
    type: FileOrder.MODIFY_TIME_DESC,
    title: 'sorter-time-descend',
  },
  {
    type: FileOrder.MODIFY_TIME_ASC,
    title: 'sorter-time-ascend',
  },
  {
    type: FileOrder.SIZE_DESC,
    title: 'sorter-size-descend',
  },
  {
    type: FileOrder.SIZE_ASC,
    title: 'sorter-size-ascend',
  },
]

const title = computed(() => orderOptions.find(el => el.type === orderTypeValue.value)?.title)

const change = () => {
  popoverRef.value?.hide?.()
  emits('afterSort')
}
</script>

<template>
  <BaseSorterShim
    v-if="showShim"
    :size="size"
    @change="change"
  />
  <ElPopover
    v-else
    ref="popoverRef"
    :placement="size === 'small' ? 'bottom-end' : 'top'"
    :width="size === 'small' ? 192 : 212"
    popper-class="base-sorter"
    trigger="click"
  >
    <template #reference>
      <a
        :class="size || ''"
        class="sort-button hover-able"
        href="javascript:void(0);"
        style="white-space: nowrap"
      >
        {{ $t(title || '') }}
        <DownIcon
          :size="size === 'small' ? 22 : 24"
          hover-able
        />
      </a>
    </template>
    <BaseSorterShim
      :size="size"
      @change="change"
    />
  </ElPopover>
</template>

<style lang="less" scoped>
@import '@/assets/styles/screen.less';
.sort-button {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  height: 36px;
  min-width: 36px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: all var(--transition-delay) var(--transition-animation);

  &:disabled,
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .pc({
    &:hover {
      color: var(--color-primary) !important;
    }
  });
}

.sort {
  &.small {
    li {
      height: 40px;
      border-radius: 2px;
      font-size: 13px;
    }
  }

  li {
    display: flex;
    align-items: center;
    height: 48px;
    line-height: 1.5;
    padding: 0 10px;
    cursor: pointer;
    border-radius: 4px;

    &:hover,
    &.active {
      background: var(--color-hover);
    }
  }
}
</style>

<style lang="less" scoped>
@import '@/assets/styles/screen.less';

.pp-link-button {
  &.small {
    font-size: 13px;
  }
}

.base-sorter {
  min-width: 140px !important;
}
</style>
